(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("SlotMachine", [], factory);
	else if(typeof exports === 'object')
		exports["SlotMachine"] = factory();
	else
		root["SlotMachine"] = factory();
})(self, () => {
return 